export default __webpack_public_path__ + "static/media/hotel-bell.f7dab132.wav";